// extracted by mini-css-extract-plugin
export default {"btop":"_91886d3929 _8ad7b9d3e1 _89f26717f2","icon":"af9aeedd2a _106eefe863","btoppink":"_70f673d152 a245c9695d"};